import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";

export class MiniMusicGameButton extends SceneDraggable {
    cancelSelectionWhenAnotherDragStarts = true;
}
